/**
 * Campo de busca único (omnibox) das listagens do admin.
 * Enter ou o botão disparam onSearch; o X limpa e re-busca.
 */
const SearchInput = ({ value, onChange, onSearch, onClear, placeholder }) => (
    <form
        className="flex min-w-[280px] flex-1 items-center gap-1 rounded-lg border border-primary/40 bg-mgs-surface px-2 py-1 focus-within:border-primary"
        onSubmit={(e) => { e.preventDefault(); onSearch(); }}
        role="search"
    >
        <span aria-hidden="true" className="px-1 text-laranjinha/50">⌕</span>
        <input
            className="w-full bg-transparent py-1 text-laranjinha placeholder-laranjinha/40 outline-none"
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
        />
        {value ? (
            <button
                type="button"
                aria-label="Limpar busca"
                className="px-2 text-laranjinha/60 hover:text-laranjinha"
                onClick={onClear}
            >
                ×
            </button>
        ) : null}
        <button
            type="submit"
            className="whitespace-nowrap rounded bg-primary px-3 py-1 text-sm font-semibold text-black hover:bg-[#b47c06]"
        >
            Buscar
        </button>
    </form>
);

export default SearchInput;
